import request from '@/utils/request';
import type { DressColorAnalysis } from '@/utils/dressColorHint';

export const uploadImage = async (blob: Blob, scene: 'dress_origin' | 'dress_thumb', fileName: string, itemId: string, color?: DressColorAnalysis) => {
  const digest = new Uint8Array(await crypto.subtle.digest('SHA-256', await blob.arrayBuffer()));
  const requestId = itemId + '-' + Array.from(digest.slice(0, 16), byte => byte.toString(16).padStart(2, '0')).join('');
  const form = new FormData();
  form.append('metadata', JSON.stringify({ scene, file_name: fileName, file_size: blob.size,
    content_type: 'image/png', client_request_id: requestId, ...(color ? { color_analysis: color } : {}) }));
  form.append('file', blob, fileName);
  const result = await request.post<never, { status: string; url?: string }>('/api/upload/image', form, { timeout: 120000 });
  if (result.status !== 'completed' || !result.url) throw new Error('图片上传未完成，请重试');
  return result.url;
};
